import { useEffect } from 'react';

/**
 * This React hook is used to detect the key user press
 * @param callback function
 * @returns void
 */

const useKeyDown = (onKeyDown: () => void, key: string): void => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === key) {
        onKeyDown();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onKeyDown, key]);
};

export default useKeyDown;
